import React from "react";
import { useLanguageContext } from "../../Context/LanguageContext";

const ConfirmationPopUp = (props) => {
  const {
    isOpen,
    okCancelCallback,
    close,
    title,
    msg,
    eventType,
    callbackData,
    isCancelShow = true,
  } = props;
  const { localization } = useLanguageContext();
  var displaystyle = isOpen ? { display: "block" } : { display: "none" };
  var _class = isOpen ? "show" : "";
  //var _inputForm = inputForm.isOpen ? inputForm.result : null;

  return isOpen ? (
    <div>
      {" "}
      <div className="overlay"></div>
      <div
        className={"modal in " + _class}
        id="ConfirmationPopUp"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="ConfirmationPopUpTitle"
        aria-hidden="true"
        style={({ opacity: "1", width: "700px" }, displaystyle)}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            {/* <div className="modal-header">
            <h5 className="modal-title" id="MsgModalLongTitle">
              {title}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                close();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div> */}
            <div className="modal-body confrimation-modal-body">
              <h2 className="pt-5 text-center">{msg}</h2>
            </div>
            <div className="modal-footer p-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  okCancelCallback(true, eventType, callbackData);
                }}
              >
                {localization.ok}
              </button>
              {isCancelShow && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    okCancelCallback(false, eventType, callbackData);
                  }}
                >
                  {localization.cancel}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
export default ConfirmationPopUp;
